import React from 'react';
import FarmMovementDetailsComponents from "../../components/FarmsComponents/FarmMovementDetailsComponents";
import { Link } from "react-router-dom";
import Auth from "../../services/Auth.service";
import { useTranslation } from "react-i18next";
import FarmsService from "../../services/farms.service";

export default function FarmMovementDetails(props) {

    const { t } = useTranslation();
    const { params } = props.match;
    const [farm, setFarm] = React.useState({
        "farmId": 0,
        "integratorId": 0,
        "integratorCode": "",
        "manufacturerCode": "",
        "name": "",
        "officialMark": "",
        "regaCode": "",
        "gpsCordinates": "",
        "address": "",
        "city": "",
        "postcode": "",
        "provinceId": 0,
        "countryId": "",
        "remarks": "",
        "isInactive": true,
        "region": "",
        "distributionZoneId": 0,
        "farmTypeId": 0,
        "efficiencyRatio": 0
    });
    const [movement, setMovement] = React.useState({
        "movementId": 0,
        "integratorId": 0,
        "farmId": 0,
        "groupId": 0,
        "movementTypeId": 0,
        "movementDate": "",
        "description": "",
        "heads": 0,
        "status": 0,
        "isClosed": true,
        "origin": "",
        "averageWeight": 0,
        "exported": true,
        "reference": "",
        "planned": true,
        "integratorName": "",
        "farmName": "",
        "movementTypeDescription": "",
        "statusDescription": ""
    });

    React.useEffect(() => {
        FarmsService.getFarm(params.farmId)
            .then(response => response.data)
            .then(json => {
                setFarm({
                    "farmId": json.contract.farmId,
                    "integratorId": json.contract.integratorId,
                    "integratorCode": json.contract.integratorCode,
                    "manufacturerCode": json.contract.manufacturerCode,
                    "name": json.contract.name,
                    "officialMark": json.contract.officialMark,
                    "regaCode": json.contract.regaCode,
                    "gpsCordinates": json.contract.gpsCordinates,
                    "address": json.contract.address,
                    "city": json.contract.city,
                    "postcode": json.contract.postcode,
                    "provinceId": json.contract.provinceId,
                    "countryId": json.contract.countryId,
                    "remarks": json.contract.remarks,
                    "isInactive": json.contract.isInactive,
                    "region": json.contract.region,
                    "distributionZoneId": json.contract.distributionZoneId,
                    "farmTypeId": json.contract.farmTypeId,
                    "efficiencyRatio": json.contract.efficiencyRatio
                });

            });
    }, [params.farmId]);

    React.useEffect(() => {
        FarmsService.getFarmMovement(params.farmId, params.movementId)
            .then(response => response.data)
            .then(json => {
                setMovement({
                    "movementId": json.contract.movementId,
                    "integratorId": json.contract.integratorId,
                    "farmId": json.contract.farmId,
                    "groupId": json.contract.groupId,
                    "movementTypeId": json.contract.movementTypeId,
                    "movementDate": json.contract.movementDate,
                    "description": json.contract.description,
                    "heads": json.contract.heads,
                    "status": json.contract.status,
                    "isClosed": json.contract.isClosed,
                    "origin": json.contract.origin,
                    "averageWeight": json.contract.averageWeight,
                    "exported": json.contract.exported,
                    "reference": json.contract.reference,
                    "planned": json.contract.planned,
                    "integratorName": json.contract.integratorName,
                    "farmName": json.contract.farmName,
                    "movementTypeDescription": json.contract.movementTypeDescription,
                    "statusDescription": json.contract.statusDescription
                });

            });
    }, [params.farmId, params.movementId]);

    return (
        <div>
            {Auth.isUserLoged ? <div>
                <br />
                <div className="container-fluid">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0"> {/* Añadí mb-0 para eliminar margen inferior */}
                            <li className="breadcrumb-item"><Link to={'/home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                            <li className="breadcrumb-item"><Link to={'/Farms/'}>{t("Global_Label_Text_Farms")}</Link></li>
                            <li className="breadcrumb-item"><Link to={'/Farms/' + farm.farmId + '/GeneralInformation'}>{farm.name}</Link></li>
                            <li className="breadcrumb-item"><Link to={'/Farms/' + farm.farmId + '/Movements'}>{t("Farm_Details_Movements")}</Link></li>
                            <li className="breadcrumb-item"><Link to={'/Farms/' + farm.farmId + '/Movements/' + movement.movementId}>{movement.movementId}</Link></li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <div>
                    <FarmMovementDetailsComponents
                        movement={movement}
                        farm={farm}
                    />
                </div>
                <br />
            </div > : ""}
        </div>
    );

}
